<div class ="user-avatar-container">
  <img src="{{avatarUrl}}"  class="user-avatar">
  <p class="text">{{text}}</p>
</div>
